import React, { useEffect, useState } from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowBackOutlined, CalendarMonthOutlined } from "@mui/icons-material";
import LandingLayout from "../../../layout/LandingLayout";
import { colors, theme } from "../../../theme/theme";
import axiosInstance from "../../../utils/config/config";

const LandingPostDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const postId = location.state?.postId;

  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const { data } = await axiosInstance.get(`/post/getPostById/${postId}`);
        setPost(data);
      } catch (error) {
        setPost(null);
      } finally {
        setLoading(false);
      }
    };

    if (postId) {
      fetchPost();
    } else {
      setLoading(false);
    }
  }, [postId]);

  if (loading) {
    return <LandingLayout />;
  }

  if (!post) {
    return (
      <LandingLayout>
        <Typography
          sx={{
            color: "rgba(255,255,255,0.6)",
            fontFamily: "Mulish-Regular",
            fontSize: "14px",
          }}
        >
          Post not found.
        </Typography>
      </LandingLayout>
    );
  }

  return (
    <LandingLayout>
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        onClick={() => navigate("/posts")}
        sx={{ cursor: "pointer", mb: 2, width: "fit-content" }}
      >
        <ArrowBackOutlined sx={{ color: colors.secondary, fontSize: "18px" }} />
        <Typography
          sx={{
            color: colors.secondary,
            fontFamily: "Mulish-SemiBold",
            fontSize: "14px",
          }}
        >
          Back to Posts
        </Typography>
      </Stack>

      <Box
        sx={{
          borderRadius: "18px",
          overflow: "hidden",
          border: theme.lightBorder,
        }}
      >
        <Box
          component="img"
          src={post.images?.[0]?.image_url}
          alt={post.title}
          sx={{
            width: "100%",
            height: { xs: "220px", md: "360px" },
            objectFit: "cover",
            display: "block",
          }}
        />

        <Box sx={{ p: { xs: 3, md: 4 } }}>
          <Typography
            sx={{
              color: "#fff",
              fontFamily: "Mulish-ExtraBold",
              fontSize: { xs: "26px", md: "32px" },
              mb: 1,
            }}
          >
            {post.title}
          </Typography>

          <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
            <CalendarMonthOutlined
              sx={{ color: colors.secondary, fontSize: "18px" }}
            />
            <Typography
              sx={{
                color: "rgba(255,255,255,0.7)",
                fontFamily: "Mulish-Regular",
                fontSize: "13px",
              }}
            >
              {post.date}
            </Typography>
          </Stack>

          <Typography
            sx={{
              color: "rgba(255,255,255,0.75)",
              fontFamily: "Mulish-Regular",
              fontSize: "14px",
              mb: 3,
            }}
          >
            {post.content}
          </Typography>

          {post.images?.length > 1 && (
            <Grid container spacing={1.5}>
              {post.images.slice(1).map((image, index) => (
                <Grid item size={{ xs: 6, sm: 4, md: 3 }} key={index}>
                  <Box
                    component="img"
                    src={image.image_url}
                    alt={`${post.title}-${index}`}
                    sx={{
                      width: "100%",
                      height: "120px",
                      objectFit: "cover",
                      borderRadius: "10px",
                      display: "block",
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          )}
        </Box>
      </Box>
    </LandingLayout>
  );
};

export default LandingPostDetails;
